//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// custom pages
import config from "config/index";
import HandleApiResponse from "helpers/handleApiResponse";

function manageSignatureAccountsAPI() {
  const { handleResponse, handleError } = HandleApiResponse();

  async function getAPI(values) {
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let query;
      query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/manage-signature-accounts?query=${query}`,
        obj
      );

      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function searchAPI(values) {
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let query;
      query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/manage-signature-accounts/search?query=${query}`,
        obj
      );

      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function filterAPI(values) {
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let query;
      query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/manage-signature-accounts/filter?query=${query}`,
        obj
      );

      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function updateAPI(values) {
    try {
      const obj = {
        method: "PUT",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-panel/manage-signature-accounts`, obj);
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function courtesyPointsCalculation(values) {
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let query;
      query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/manage-signature-accounts/courtesy-points-calculation?query=${query}`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function bulkSignatureUnEnroll(values) {
    try {
      const obj = {
        method: "PATCH",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values)
      };
      let res = await fetch(
        `${config.host}/cdr-panel/manage-signature-accounts/bulk-un-enroll`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function exportAPI(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-panel/manage-signature-accounts/export`, obj);

      return handleResponse(res);

    } catch (err) {
      handleError(err);

    }
  }
  async function updateprivilegeAPI(values) {
    try {
      const obj = {
        method: "PUT",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-panel/manage-signature-accounts/privilege-update`, obj);
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }


 async function getviewplan(values) {
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let query;
      query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/manage-signature-accounts/plan-change?query=${query}`,
        obj
      );

      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

   async function updatemomentum(values) {
    try {
      const obj = {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-panel/manage-signature-accounts/momentum-update`, obj);
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  
  
  return {
    getAPI,
    searchAPI,
    updateAPI,
    courtesyPointsCalculation,
    bulkSignatureUnEnroll,
    exportAPI,
    updateprivilegeAPI,
    getviewplan,
    filterAPI,
    updatemomentum
    
  };
}

export default manageSignatureAccountsAPI;
